import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appEvoDnd]',
})
export class EvoDndDirective {
  @Output() fileHover = new EventEmitter<any>();
  @Output() fileLeave = new EventEmitter<any>();

  @Output() fileDropped = new EventEmitter<any>();
  @HostBinding('style.background-color') public background = '#fff';

  @HostBinding('class') public dropClass = '';

  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#FAFAFA';
    this.dropClass = 'drag-hover';

    this.fileHover.emit();
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#fff';

    this.fileLeave.emit();
  }

  @HostListener('drop', ['$event']) public ondrop(evt) {
    if (evt.dataTransfer.files?.length == 0) {
      this.onDragLeave(evt);
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#fff';
    this.dropClass = '';

    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
      this.fileLeave.emit();
    }
  }

  constructor() {}
}
